export default "__VITE_ASSET__YsAXz4$n1Qn9EsZBFmhgrA__"